import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './SliderArrow.module.scss'

interface ArrowProps {
  direction: 'left' | 'right'
  disabled?: boolean
  onClick?: (event) => void
}
export const SliderArrow: FC<ArrowProps> = ({ direction, disabled = false, onClick }) => (
  // eslint-disable-next-line jsx-a11y/control-has-associated-label
  <button
    className={clsx(styles.sliderArrow, disabled && styles.disabled, styles[direction])}
    onClick={onClick}
    type="button"
  >
    <svg
      focusable="false"
      height="40"
      viewBox="0 0 40 40"
      width="40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11,0L8.4,2.7L26.2,20L8.4,37.3L11,40l20.6-20L11,0z" />
    </svg>
  </button>
)
